import axios from 'axios';
import { CLIENT_NAME } from '../../../constants/companyConfig';

export const fetchWorkflows = async (token, deleteStatus, handleLogout) => {
  if (!token) {
    handleLogout();
    return [];
  }
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/workflows/list`,
      {
        deleted_at: deleteStatus || null,
        workflow_client: CLIENT_NAME,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      }
    );
    return response.status === 200 ? response.data : [];
  } catch (error) {
    console.error('Error fetching workflows:', error);
    if (error.response?.status === 401) handleLogout();
    return [];
  }
};

export const deleteWorkflow = async (workflowId, token) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/workflows/soft-delete/${workflowId}`,
      {
        method: 'DELETE',
        headers: { Authorization: `${token}` },
      }
    );
    return response.ok;
  } catch (error) {
    console.error('Error deleting workflow:', error);
    return false;
  }
};

export const toggle = async (workflow) => {
  try {
  } catch {}
};
